
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulic04Off as ObiHydraulic04OffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-04-off.js';
 
 
 

 
 export const ObiHydraulic04Off = createComponent({
   react: React,
   tagName: 'obi-hydraulic-04-off',
   elementClass: ObiHydraulic04OffElement,
   events: {
     
   }
  });
 
 